import * as index from './index';
index.Gantt.Inject(index.Filter, index.Selection, index.Sort, index.Reorder, index.Resize, index.Edit, index.DayMarkers, index.Toolbar, index.ContextMenu, index.ExcelExport, index.RowDD, index.ColumnMenu, index.PdfExport, index.VirtualScroll, index.CriticalPath, index.UndoRedo, index.Freeze);
export * from './index';
